import { useInfiniteQuery } from "@tanstack/react-query";
import { fetchDosen } from "./api/get-dosen";
import { columns } from "./components/columns";
import { DataTable } from "@/components/ui/data-table";
import React from "react";

export default function MasterDataDosenPage() {
  const limit = 10;

  const {
    data,
    isLoading,
    isError,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useInfiniteQuery({
    queryKey: ["master-dosen"],
    queryFn: ({ pageParam }) => fetchDosen({ pageParam, limit }),
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage?.is_next || (lastPage?.datas && lastPage.datas.length === limit)) {
        return allPages.length + 1;
      }
      return undefined;
    },
  });

  const dosenData = React.useMemo(() => {
    const rawData = data?.pages.flatMap((page) => page.datas) || [];
    const unique = new Map();
    rawData.forEach((item, index) => {
      if (item) {
        // Karena dosen_id dari API bisa bernilai 0, kita gunakan fallback ke identifier lain agar tidak saling menimpa
        const key = item.dosen_id || item.no_induk_undiksha || item.nidn || item.nip || index;
        unique.set(key, item);
      }
    });
    return Array.from(unique.values());
  }, [data]);

  const totalLoaded = dosenData.length;
  const currentPageLoaded = data?.pages.length || 0;

  if (isLoading) {
    return <div className="p-6">Loading data dosen...</div>;
  }

  if (isError) {
    return (
      <div className="p-6 text-red-500">Error: {(error as Error).message}</div>
    );
  }

  return (
    <div className="p-6 space-y-6">
      <div className="flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">
            Master Data Dosen
          </h1>
          <p className="text-sm text-slate-500 mt-1">
            Menampilkan{" "}
            <span className="font-semibold text-slate-900">{totalLoaded}</span>{" "}
            data yang telah diload dari{" "}
            <span className="font-semibold text-slate-900">
              {currentPageLoaded}
            </span>{" "}
            halaman.
          </p>
        </div>
      </div>

      <div className="bg-card">
        <DataTable
          columns={columns}
          data={dosenData}
          onReachBottom={() => {
            if (hasNextPage && !isFetchingNextPage) {
              fetchNextPage();
            }
          }}
          isFetchingNextPage={isFetchingNextPage}
          hasNextPage={hasNextPage}
        />
      </div>
    </div>
  );
}
